export default context => {
    if (
        window &&
        window.IntersectionObserver &&
        typeof window.IntersectionObserver === "function"
    ) {
        const observer = new IntersectionObserver(callback, {rootMargin: "25%", threshold: 0});
        //
        $(".lazy-loaded-container", context).each(function (i, elem) {
            // container has children
            observer.observe(elem);
        });
        //
        $(".lazy-loaded", context).each(function (i, elem) {
            if ($(elem).parents(".lazy-loaded-container").length === 0) {
                // child has no container
                observer.observe(elem);
            }
        });
    } else {
        $(".lazy-loaded", context).each(function (i, elem) {
            loadLazyLoadImage(elem);
        });
    }
}
const callback = function (e, observer) {
    for (var i = 0; i < e.length; i++) {
        var entry = e[i];
        if (entry.isIntersecting) {
            observer.unobserve(entry.target);
            if (entry.target.className.indexOf("lazy-loaded-container") > -1) {
                $(entry.target)
                    .find(".lazy-loaded")
                    .each(function (i, elem) {
                        loadLazyLoadImage(elem);
                    });
                entry.target.className = entry.target.className.replace(
                    "lazy-loaded-container",
                    ""
                );
            } else {
                loadLazyLoadImage(entry.target);
            }
        }
    }
}

const loadLazyLoadImage = function (elem) {
    if (elem) {
        elem.className = elem.className.replace("lazy-loaded", "");
        var src = elem.getAttribute("data-src");
        var style = elem.getAttribute("data-style");
        if (src) {
            elem.setAttribute("src", src);
            elem.removeAttribute("data-src");
        } else if (style) {
            elem.setAttribute("style", style);
            elem.removeAttribute("data-style");
        }
    }
};
